import { Box, Typography } from "@mui/material";
import { QRCodeSVG } from "qrcode.react";

import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";

interface EpcQrCodeProps {
  swift: string;
  actorName: string;
  iban: string;
  amount: number;
}

function buildEpcString({
  swift,
  actorName,
  iban,
  amount,
}: EpcQrCodeProps): string {
  // EPC QR Code format (SEPA Credit Transfer)
  // See: https://www.europeanpaymentscouncil.eu/document-library/guidance-documents/quick-response-code-guidelines
  const lines = [
    "BCD", // Service Tag
    "002", // Version
    "1", // Character set (UTF-8)
    "SCT", // Identification
    swift, // BIC of the Beneficiary Bank
    actorName, // Name of the Beneficiary
    iban, // Account number of the Beneficiary (IBAN)
    `EUR${amount.toFixed(2)}`, // Amount
    "", // Purpose of the credit transfer (empty)
    "", // Structured remittance reference (empty)
    "", // Unstructured remittance text (empty)
    "", // Beneficiary to originator information (empty)
  ];
  return lines.join("\n");
}

export const EpcQrCode = ({
  swift,
  actorName,
  iban,
  amount,
}: EpcQrCodeProps): React.ReactNode => {
  const { t } = useResource();

  const epcString = buildEpcString({ swift, actorName, iban, amount });

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: Spacing.S }}>
        {t(Resources.WithdrawalApprovals.EpcQrCode)}
      </Typography>
      <Box
        sx={(theme) => ({
          display: "inline-flex",
          p: Spacing.M,
          borderRadius: 2,
          // QR codes need a light quiet zone to stay scannable on the dark UI.
          backgroundColor: theme.palette.common.white,
        })}
      >
        <QRCodeSVG value={epcString} size={200} level="M" />
      </Box>
    </Box>
  );
};
